export default __webpack_public_path__ + "assets/fog.0103d56b.svg";